import ProductsBiologicalComponents from "./step-components/Products/Biological/ProductsBiologicalComponents";
import ProductsNutrientsComponent from "./step-components/Products/ProductsNutrientsComponent";
import ProductsSeedComponent from "./step-components/Products/ProductsSeedComponent";
import { type objectivesTargetType, type ProtocolStepItemType } from "./types";

export const protocolsSteps: ProtocolStepItemType[] = [
  {
    title: "Trial Type",
    path: "trial-type",
    stepNumber: 1,
  },
  {
    title: "Protocol Rules",
    path: "rules",
    stepNumber: 2,
  },

  {
    title: "Products",
    path: "products",
    stepNumber: 3,
  },
  {
    title: "Summary",
    path: "summary",
    stepNumber: 4,
  },
];

export const SUBMIT_PROTOCOL_LABEL = "Save and configure trial";
export const targets: objectivesTargetType[] = [
  {
    label: "createProtocol.objectives.objectiveItemTarget.yield",
    value: "Yield",
  },
  {
    label: "createProtocol.objectives.objectiveItemTarget.moisture",
    value: "Moisture",
  },
  {
    label: "createProtocol.objectives.objectiveItemTarget.peakNDVI",
    value: "Peak NDVI",
  },
  {
    label: "createProtocol.objectives.objectiveItemTarget.dryMatter",
    value: "Dry Matter",
  },
  {
    label:
      "createProtocol.objectives.objectiveItemTarget.yieldAtStandardMoisture",
    value: "Yield at standard moisture (15%)",
  },
  {
    label: "createProtocol.objectives.objectiveItemTarget.specificWeight",
    value: "Specific weight (kg/hl)",
  },
  {
    label: "createProtocol.objectives.objectiveItemTarget.plantHeight",
    value: "Plant height (cm)",
  },
  {
    label: "createProtocol.objectives.objectiveItemTarget.lodgingPercent",
    value: "Lodging %",
  },
  {
    label:
      "createProtocol.objectives.objectiveItemTarget.infectionByDiseasePercent",
    value: "% Infection by disease",
  },
  // {
  //   label: "Seed Rate",
  //   value: "seed_rate",
  // },
  // {
  //   label: "Sunflower Rate",
  //   value: "sunflower_rate",
  // },
  // {
  //   label: "Silage Rate",
  //   value: "silage rate",
  // },
  // {
  //   label: "Cereals Rate",
  //   value: "cereals rate",
  // },
  // {
  //   label: "Fert Rate",
  //   value: "fert rate",
  // },
];

export const targetsLabels: Record<string, string> = {
  Yield: "createProtocol.objectives.objectiveItemTarget.yield",
  Moisture: "createProtocol.objectives.objectiveItemTarget.moisture",
  "Peak NDVI": "createProtocol.objectives.objectiveItemTarget.peakNDVI",
  "Dry Matter": "createProtocol.objectives.objectiveItemTarget.dryMatter",
  "Yield at standard moisture (15%)":
    "createProtocol.objectives.objectiveItemTarget.yieldAtStandardMoisture",
  "Specific weight (kg/hl)":
    "createProtocol.objectives.objectiveItemTarget.specificWeight",
  "Plant height (cm)":
    "createProtocol.objectives.objectiveItemTarget.plantHeight",
  "Lodging %": "createProtocol.objectives.objectiveItemTarget.lodgingPercent",
  "% Infection by disease":
    "createProtocol.objectives.objectiveItemTarget.infectionByDiseasePercent",
};

export const dummyObjectives = [
  {
    name: "First Objective",
    target: "Crop Establishment",
    description: "This is a test description for the first objective",
  },
  {
    name: " Objective 2",
    target: "Crop Establishment",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
  },
];

export const measureUnitOptions = [
  {
    value: "seeds/m2",
    label: (
      <>
        seeds/m<sup>2</sup>
      </>
    ),
  },
  {
    value: "seeds/ha",
    label: <>seeds/ha</>,
  },
  {
    value: "kg/ha",
    label: <>kg/ha</>,
  },
];

export const nutrientTypeOptions: any = [
  {
    label: <span className="nutrient-type-category">Basic Nutrients</span>,
    title: "Basic Nutrients",
    options: [
      { label: <span>N | Nitrogen</span>, value: "N", key: "nitrogen" },
      {
        label: <span>P | Phosphorus (P2O5 | Phosphorus Pentoxide)</span>,
        value: "P",
        key: "phosphorusPentoxide",
      },
      {
        label: <span>K | Potassium (K2O | Potassium Oxide)</span>,
        value: "K",
        key: "potassiumOxide",
      },
    ],
  },
  {
    label: <span className="nutrient-type-category">Aditional Nutrients</span>,
    title: "Aditional Nutrients",
    options: [
      { label: <span>Cd | Cadmium</span>, value: "Cd", key: "cadmium" },
      { label: <span>Cr | Chromium</span>, value: "Cr", key: "chromium" },
      { label: <span>Pb | Lead</span>, value: "Pb", key: "lead" },
      { label: <span>Hg | Mercury</span>, value: "Hg", key: "mercury" },
    ],
  },
  {
    label: <span className="nutrient-type-category">Other Nutrients</span>,
    title: "Aditional Nutrients",
    options: [
      { label: <span>Al | Aluminum</span>, value: "Al", key: "aluminum" },
      { label: <span>B | Boron</span>, value: "B", key: "boron" },
      { label: <span>Ca | Calcium</span>, value: "Ca", key: "calcium" },
      { label: <span>Co | Cobalt</span>, value: "Co", key: "cobalt" },
      { label: <span>Cu | Copper</span>, value: "Cu", key: "copper" },
      { label: <span>Fe | Iron</span>, value: "Fe", key: "iron" },
      { label: <span>Mg | Magnesium</span>, value: "Mg", key: "magnesium" },
      { label: <span>Mn | Manganese</span>, value: "Mn", key: "manganese" },
      { label: <span>Mo | Molybdenum</span>, value: "Mo", key: "molybdenum" },
      { label: <span>Ni | Nickel</span>, value: "Ni", key: "nickel" },
      { label: <span>Se | Selenium</span>, value: "Se", key: "selenium" },
      { label: <span>Si | Silicon</span>, value: "Si", key: "silicon" },
      { label: <span>Na | Sodium</span>, value: "Na", key: "sodium" },
      { label: <span>S | Sulfur</span>, value: "S", key: "sulfur" },
      { label: <span>Zn | Zinc</span>, value: "Zn", key: "zinc" },
    ],
  },
];

export const protocolProductTabs = (protocolType: string[]): any[] => {
  const tabs = [];
  // Maintain explicit order: Seed -> Biological -> Nutrient
  if (protocolType.includes("seed")) {
    tabs.push({
      key: "seed",
      label: "Seeds",
      children: <ProductsSeedComponent />,
      forceRender: true,
    });
  }
  if (protocolType.includes("biological")) {
    tabs.push({
      key: "biological",
      label: "CP and Biologicals",
      children: <ProductsBiologicalComponents />,
      forceRender: true,
    });
  }
  if (protocolType.includes("nutrient")) {
    tabs.push({
      key: "nutrient",
      label: "Nutrients",
      children: <ProductsNutrientsComponent />,
      forceRender: true,
    });
  }
  return tabs;
};

export const BiologicalProductOptions: any = [
  {
    label: <span>Product One</span>,
    value: "1",
    key: "product1",
  },
  {
    label: <span>Product Two</span>,
    value: "2",
    key: "product1",
  },
  {
    label: <span>Product Three</span>,
    value: "3",
    key: "product1",
  },
  {
    label: <span>Product Four</span>,
    value: "4",
    key: "product1",
  },
  {
    label: <span>Product Five</span>,
    value: "5",
    key: "product1",
  },
];
